<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} ALERT AAAAAAAA</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <label class="vs-select--label w-full">Message *</label>
        <vs-textarea label="" v-model="dataMessage" name="message" v-validate="'required'"/>
       <label class="vs-select--label w-full">Select Location *</label>
       <label class="ml-5 vs-select--label" @click="allLocation" style="float:right">Select All</label>
        <v-select  label="name" multiple @input="getProgram()" :closeOnSelect="true" v-model="dataLocation"  :options="locations"  /><br> 
        <label class="vs-select--label w-full">Select Program *</label><label class=" vs-select--label" @click="allProgram" style="float:right">Select All</label>
        <v-select label="name"  multiple @input="getStudent()" :closeOnSelect="true" v-model="dataProgram"  :options="programs"  /><br>
         
        <div v-for="(student,index) in students" :key="index">
         <vs-row v-if="student.users.length > 0">
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12" class="ml-0">
        <div class="flex">
        <div v-if="student.image" class="mr-2"><vs-avatar class="m-0" :src="img_cdn+student.image"  size="35px" /></div>
        <div v-else class="mr-2"><vs-avatar class="m-0" :src="student.image"  size="35px" /></div>
        <p class="font-medium mt-2">{{ student.fname }} {{ student.lname }}</p>
          </div>
         </vs-col>
          <vs-col v-for="(user,indexx) in student.users" :key="indexx" vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
           <vs-checkbox v-model="user.check"></vs-checkbox>
          <vs-chip>
          {{user.fname}} {{user.lname}}
               </vs-chip> 
         </vs-col>
        </vs-row>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6 vs-con-loading__container" ref="loadableButton" id="button-with-loading"  @click.native="submitData" :disabled="!isFormValid">{{$t('student.add.btn_submit')}}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{$t('student.add.btn_cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>


<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import {
  ALL_MANGER_LOCATIONS,
  ALL_ROLES_QUERY,
  CREATE_ALERT,
  UPDATE_ANNOUNCEMENT,
  DROPDOWN_ALL_LOCATIONS,
  GET_PROGRAM_BY_LOCATIONS,
  GET_STUDENT_BY_PROGRAMS,
  MANAGER_LOCATION,
  USER_LOCATION 
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      dataId:null,
      dataMessage:'',
      locations:[],
      programs:[],
      students:[],
      dataLocation:'',
      dataProgram:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      img_cdn: '',
      btnDisable:true
      // deselectedOption:''
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, locations, roles, message, status} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataStatus = status
        this.dataRole = roles
        this.dataLocation = locations
        this.dataMessage = message
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataMessage && this.dataLocation && this.dataProgram && this.students && this.btnDisable
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    allLocation () {
      if (this.dataLocation.length === this.locations.length) {
        this.dataLocation = []
      } else {
        this.dataLocation = this.locations
      }
      this.getProgram()
    },
    allProgram () {
      if (this.dataProgram.length === this.programs.length) {
        this.dataProgram = []
      } else {
        this.dataProgram = this.programs
      }
      this.getStudent()
    },
    getProgram () {
      this.students = []    
      this.programs = [] 
      this.dataProgram = ''
      const locations = []
      if (this.dataLocation.length > 0) {
        for (let i = 0; i < this.dataLocation.length; i++) {
          locations.push(this.dataLocation[i].id)
        }  
        this.$apollo
          .mutate({
            mutation: GET_PROGRAM_BY_LOCATIONS,
            variables: {
              location_id:locations
            }
          })
          .then(response => {
            if (response) {
              for (let index = 0; index < response.data.locations_programs.length; index++) {
                this.programs.push(response.data.locations_programs[index])
              }
            }
          }).catch(error => {
            console.log(error)
          })
      }
    },
    getStudent () {
      this.students = []
      const  program = []
      if (this.dataProgram.length > 0) {
        for (let i = 0; i < this.dataProgram.length; i++) {
          program.push(this.dataProgram[i].id)
        }
        this.$apollo
          .mutate({
            mutation: GET_STUDENT_BY_PROGRAMS,
            variables: {
              program_id:program
            }
          })
          .then(response => {
            if (response) {
              const listStudent = response.data.programsStudent
              // this.students = listStudent
              if (listStudent.length > 0) {
                for (let i = 0; i < listStudent.length; i++) {
                  if (listStudent[i].users.length > 0) {
                    const listusers = []
                    for (let j = 0; j < listStudent[i].users.length; j++) {
                      const user = listStudent[i].users[j]
                      if (user.phone) {
                        user.check = true  
                        listusers.push(user)
                      }  
                    }

                    listStudent[i].users = listusers
                  }
                  if (listStudent[i].users.length > 0) {
                    this.students.push(listStudent[i])
                  }  
                }
              }
            }
          }).catch(error => {
            console.log(error)
          })
      }
    },
    StatusSuccess (msg) {
      this.$vs.notify({
        title: 'Alert',
        text:  msg,
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataLocation = ''
      this.dataMessage = ''
      this.dataProgram = ''
      this.dataId = null
      this.programs = []
      this.students = []
      this.btnDisable = true
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: this.$refs.loadableButton.$el,
        scale: 0.45
      })
    },
    submitData () {
      this.btnDisable = false
      this.openLoadingContained()
      const lastusers = []
      const roles = []
      if (this.students.length > 0) {
        for (let i = 0; i < this.students.length; i++) {
          for (let j = 0; j < this.students[i].users.length; j++) {
            if (this.students[i].users[j].check) {
              lastusers.push(this.students[i].users[j])
            }
          }
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_ANNOUNCEMENT,
                variables: {
                  id :this.dataId,
                  msg: this.dataMessage,
                  status:this.dataStatus,
                  locations,
                  roles
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess(response.data.updateAnnouncement.message, response.data.updateAnnouncement.color)
                  if (response.data.updateAnnouncement.status == 'Success') {
                    this.$vs.loading.close(this.$refs.loadableButton.$el)
                    this.btnDisable = true
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }

                }
              }).catch(error => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
              })

          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_ALERT,
                variables: {
                  msg: this.dataMessage,
                  users:lastusers
                }
              })
              .then(response => {
                if (response) {
                  this.$vs.loading.close(this.$refs.loadableButton.$el)
                  this.btnDisable = true
                  if (response.data.createAlert.status == 'Success') {
                    this.StatusSuccess(response.data.createAlert.message)
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }
                }
              }).catch(error => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true

              })
          }
        }
      })
    },
    get () {
     let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)
    },
    conditionMethod (role, id) {
      if (role === 'manager') {
        this.$apollo
          .mutate({
            mutation: MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            this.locations = response.data.user.managerlocations
          }).catch(error => {
            console.log(error)
          })
      } else if (role === 'teacher') {
        this.$apollo
          .mutate({
            mutation: USER_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            this.locations = response.data.user.locations
          }).catch(error => {
            console.log(error)
          })
      } else {
        this.$apollo
          .mutate({
            mutation: DROPDOWN_ALL_LOCATIONS
          })
          .then(response => {
            this.locations = response.data.dropdownlocations
          })
      } 
    }
  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.get()
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
